"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[284],{

/***/ 284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ intro_screen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 153 modules
var dist = __webpack_require__(33050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./hooks/index.ts + 4 modules
var hooks = __webpack_require__(19004);
// EXTERNAL MODULE: ./hooks/useLoadingProgress.tsx
var useLoadingProgress = __webpack_require__(29709);
// EXTERNAL MODULE: ./utils/muiColor.ts + 5 modules
var muiColor = __webpack_require__(14361);
;// CONCATENATED MODULE: ./components-new/common/intro-screen/IntroScreen.tsx










function IntroScreen(param) {
    var rtl = param.rtl, introScreen = param.introScreen, tour = param.tour, checkbox = param.checkbox, whiteLabelData = param.whiteLabelData, translation = param.translation, showCollectLeadsModal = param.showCollectLeadsModal, initialDuplicates = param.initialDuplicates, inputs = param.inputs, preventSubmit = param.preventSubmit, onStart = param.onStart, onFinish = param.onFinish, preventSubmitCallback = param.preventSubmitCallback;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var loadingProgress = (0,useLoadingProgress/* useLoadingProgress */.O2)().loadingProgress;
    var ref6 = (0,hooks/* useLanguage */.ZK)({
        initialDuplicates: initialDuplicates,
        tourSlug: tour === null || tour === void 0 ? void 0 : tour.slug
    }), languageOptions = ref6.languageOptions, defaultLanguage = ref6.defaultLanguage, handleChange = ref6.handleChange;
    var ref7 = (0,react.useState)(false), isStarted = ref7[0], setStarted = ref7[1];
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setStarted(true);
                onStart(data);
                return [
                    2
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onStart
    ]);
    (0,react.useEffect)(function() {
        if (showCollectLeadsModal) {
        // sendToGA('event', {
        //   eventCategory: 'Lead',
        //   eventAction: 'open',
        //   eventLabel: 'entry',
        // });
        }
    }, [
        showCollectLeadsModal
    ]);
    (0,react.useEffect)(function() {
        if (loadingProgress === 100 && isStarted) {
            onFinish();
        }
    }, [
        loadingProgress,
        onFinish,
        isStarted
    ]);
    var getBackgroundVideo = function() {
        if (introScreen === null || introScreen === void 0 ? void 0 : introScreen.videoLink) return introScreen === null || introScreen === void 0 ? void 0 : introScreen.videoLink;
        if (introScreen === null || introScreen === void 0 ? void 0 : introScreen.uploadedVideoUrl) return "".concat("https://nytimes-cdn.enterprise.treedis.com", "/").concat(introScreen === null || introScreen === void 0 ? void 0 : introScreen.uploadedVideoUrl).concat((0,util/* getVersion */.bo)(introScreen === null || introScreen === void 0 ? void 0 : introScreen.updatedAt));
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IntroScreen */.dY, {
        rtl: rtl,
        hideHelpButton: introScreen === null || introScreen === void 0 ? void 0 : introScreen.hideHelpButton,
        title: tour.showTitle ? (introScreen === null || introScreen === void 0 ? void 0 : introScreen.title) || tour.title || "" : "",
        description: (introScreen === null || introScreen === void 0 ? void 0 : introScreen.description) || tour.address || "",
        backgroundVideo: getBackgroundVideo(),
        loading: isStarted ? loadingProgress !== 100 : undefined,
        loadingProgress: loadingProgress,
        termFile: translation.termFile ? "".concat("https://nytimes-cdn.enterprise.treedis.com", "/tours/").concat(tour.id, "/termFile.pdf") : undefined,
        isTextShadowed: introScreen === null || introScreen === void 0 ? void 0 : introScreen.isTextShadowed,
        enableTips: introScreen === null || introScreen === void 0 ? void 0 : introScreen.enableTips,
        darkBackground: introScreen === null || introScreen === void 0 ? void 0 : introScreen.darkBackground,
        blurBackground: introScreen === null || introScreen === void 0 ? void 0 : introScreen.blurBackground,
        // Client logo for public is shown in the BaseTour component
        client: {
            show: !!(tour === null || tour === void 0 ? void 0 : tour.client) && (introScreen === null || introScreen === void 0 ? void 0 : introScreen.enableLogo),
            logo: (tour === null || tour === void 0 ? void 0 : tour.clientId) ? "".concat("https://nytimes-cdn.enterprise.treedis.com", "/clients/").concat(tour.clientId, "/logo.png").concat((0,util/* getVersion */.bo)((tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.updatedAt) || new Date())) : "",
            horizontalLogo: !!(tour === null || tour === void 0 ? void 0 : (ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.widthLogo),
            // eslint-disable-next-line no-nested-ternary
            website: (tour === null || tour === void 0 ? void 0 : (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.website) ? ((ref3 = tour === null || tour === void 0 ? void 0 : tour.client.website) === null || ref3 === void 0 ? void 0 : ref3.includes("https://")) ? tour === null || tour === void 0 ? void 0 : tour.client.website : "https://".concat(tour === null || tour === void 0 ? void 0 : tour.client.website) : ""
        },
        backgroundImage: (introScreen === null || introScreen === void 0 ? void 0 : introScreen.backgroundImage) ? "".concat("https://nytimes-cdn.enterprise.treedis.com", "/tours/").concat(tour.id, "/images/").concat(introScreen.backgroundImage).concat((0,util/* getVersion */.bo)(tour.updatedAt)) : "".concat("https://nytimes-cdn.enterprise.treedis.com", "/tours/").concat(tour.id, "/images/").concat(tour.mainImage).concat((0,util/* getVersion */.bo)(tour.updatedAt)),
        language: {
            options: languageOptions || [],
            default: defaultLanguage,
            onChange: handleChange
        },
        button: {
            label: tour === null || tour === void 0 ? void 0 : (ref4 = tour.translation) === null || ref4 === void 0 ? void 0 : ref4.introScreenButtonLabel,
            showPlayButton: introScreen === null || introScreen === void 0 ? void 0 : introScreen.showPlayButton,
            primaryColor: introScreen === null || introScreen === void 0 ? void 0 : introScreen.buttonPrimaryColor,
            secondaryColor: introScreen === null || introScreen === void 0 ? void 0 : introScreen.buttonSecondaryColor
        },
        whiteLabel: (0,_object_spread/* default */.Z)({
            show: Boolean(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref5 = whiteLabelData.logo) === null || ref5 === void 0 ? void 0 : ref5.length),
            isWLUser: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.isWLUser,
            logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
            website: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.website
        }, (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.primaryColor) ? {
            primaryColor: {
                light: muiColor/* default.light */.Z.light(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.primaryColor),
                main: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.primaryColor,
                dark: muiColor/* default.dark */.Z.dark(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.primaryColor)
            }
        } : {}, (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) ? {
            secondaryColor: {
                light: muiColor/* default.light */.Z.light(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor),
                main: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor,
                dark: muiColor/* default.dark */.Z.dark(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor)
            },
            textColor: {
                secondary: muiColor/* default.lighter */.Z.lighter(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor),
                primary: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor,
                disabled: muiColor/* default.light */.Z.light(whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor)
            }
        } : {}),
        inputs: inputs,
        onSubmit: handleSubmit,
        preventSubmit: preventSubmit,
        preventSubmitCallback: preventSubmitCallback,
        translation: translation,
        checkbox: checkbox
    });
}

;// CONCATENATED MODULE: ./components-new/common/intro-screen/index.ts

/* harmony default export */ var intro_screen = (IntroScreen);


/***/ })

}]);